module.exports = __webpack_public_path__ + "static/media/09_thehermit.80adbb93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/09_thehermit.png
// module id = 72
// module chunks = 0